// extracted by mini-css-extract-plugin
module.exports = {"scroll_tips":"index-scroll_tips-bh_BB","scroll-tips-move":"index-scroll-tips-move-S62I4"};